import queryString from 'query-string';
import { httpwmsapi } from 'src/services';

// Action Types
export const Types = {
  USER_ACTIONS_LOADING: 'request_inventory/loading',
  USER_ACTIONS_SET_LIST: 'request_inventory/set/list',
  USER_ACTIONS_SET_PAGING: 'request_inventory/set/paging',
  USER_ACTIONS_SET_FILTERS: 'request_inventory/set/filters',
  USER_ACTIONS_SET_ADDITIONAL_FILTERS: 'request_inventory/set/additional_filters',
  USER_ACTIONS_SET_DETAILS: 'request_inventory/set/details',
};

// Reducer
const initialState = {
  loading: false,
  user_actions_action_type_list: [
    {
      value: 'alocacao',
      label: 'Alocações',
    },
    {
      value: 'expedicao',
      label: 'Conferência para expedição',
    },
    {
      value: 'inventario',
      label: 'Inventários',
    },
    {
      value: 'movimentacao',
      label: 'Movimentações',
    },
    {
      value: 'separacao',
      label: 'Separações',
    },
    /* {
            value: "transferencia",
            label: "Transferências",
        } */
  ],
  user_actions_list: [],
  user_actions_paging: { limit: 25, offset: 0, total: 0 },
  user_actions_filters: {
    initial_date: new Date(new Date().setDate(new Date().getDate() - 30)),
    final_date: new Date(),
    action_type: {
      value: 'alocacao',
      label: 'Alocações',
    },
    user: '',
  },
  user_actions_additional_filters: {
    allocation: {
      stock_name: '',
      stock_address: '',
      product_gtin: '',
      product_sku: '',
      product_name: '',
    },
    packing: {
      order_id: '',
      marketplace_id: '',
      account_name: '',
      shipping_name: '',
      profile_name: '',
    },
    inventory: {
      stock_name: '',
      stock_address: '',
      inventory_type: '',
      inventory_status: '',
      description: '',
      operation: '',
    },
    movement: {
      stock_name: '',
      stock_address: '',
      product_gtin: '',
      product_sku: '',
      product_name: '',
    },
    picking: {
      order_id: '',
      marketplace_id: '',
      account_name: '',
      shipping_name: '',
      profile_name: '',
    },
    transfer: {
      stock_from: '',
      stock_to: '',
      product_gtin: '',
      product_sku: '',
      transfer_status: '',
    },
  },
  user_actions_details: null,
};

// Action Creators
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.USER_ACTIONS_LOADING:
      return { ...state, loading: action.payload };
    case Types.USER_ACTIONS_SET_LIST:
      return { ...state, user_actions_list: action.payload };
    case Types.USER_ACTIONS_SET_PAGING:
      return { ...state, user_actions_paging: action.payload };
    case Types.USER_ACTIONS_SET_FILTERS:
      return { ...state, user_actions_filters: action.payload };
    case Types.USER_ACTIONS_SET_ADDITIONAL_FILTERS:
      return { ...state, user_actions_additional_filters: action.payload };
    case Types.USER_ACTIONS_SET_DETAILS:
      return { ...state, user_actions_details: action.payload };
    default:
      return state;
  }
}

export const Creators = {
  userActionsLoading: (value) => ({ type: Types.USER_ACTIONS_LOADING, payload: value }),
  userActionsSetList: (value) => ({ type: Types.USER_ACTIONS_SET_LIST, payload: value }),
  userActionsSetPaging: (value) => ({ type: Types.USER_ACTIONS_SET_PAGING, payload: value }),
  userActionsSetFilters: (value) => ({ type: Types.USER_ACTIONS_SET_FILTERS, payload: value }),
  userActionsSetAdditionalFilters: (value) => ({ type: Types.USER_ACTIONS_SET_ADDITIONAL_FILTERS, payload: value }),
  userActionsSetDetails: (value) => ({ type: Types.USER_ACTIONS_SET_DETAILS, payload: value }),
  getUserActions: (params) => {
    const qry = queryString.stringify(params, { arrayFormat: 'index' });
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/acao-usuario/${params?.action_type}?${qry}`, { timeout: 1000 * 60 * 10 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
};
